// Update MoveModal.vue to ensure it handles the new structure correctly:

<template>
  <div class="move-modal" v-if="visible">
    <div class="move-modal-content">
      <h2>Select a Folder</h2>
      <select v-model="selectedFolder" ref="targetFolder">
        <option value="">-- Select Folder --</option>
        <option v-for="folder in nestedFoldersWithOptions" :key="folder.id" :value="folder">
          {{ folder.title }}
        </option>
      </select>
      <div class="modal-buttons">
        <button class="secondary" @click="cancel">Cancel</button>
        <button class="primary" @click="save" :disabled="!selectedFolder">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoveModal',
  props: {
    channelId: String,
    visible: {
      type: Boolean,
      required: true
    },
    nestedFolders: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedFolder: null
    };
  },
  computed: {
    nestedFoldersWithOptions() {
      return this.flattenNestedFolders(this.nestedFolders);
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        // Reset selection when modal is closed
        this.selectedFolder = null;
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    indentFolderTitle(title, nestLevel) {
      const indentation = " ".repeat(nestLevel * 2);
      return `${indentation}${title}`;
    },
    flattenNestedFolders(folders, level = 0) {
      let result = [];

      for (const folder of folders) {
        // Check if folder is editable and is a Folder type (or RootFolder)
        if (folder.attributes && folder.attributes.editable &&
            (folder.attributes.type === "Folder" || folder.attributes.type === "RootFolder")) {

          // Create the display title with proper indentation
          let displayTitle = folder.attributes.title;
          if (folder.attributes.type !== "RootFolder" && level > 0) {
            // Add dashes for non-root folders based on their level
            const prefix = '-'.repeat(level) + ' ';
            displayTitle = prefix + displayTitle;
          }

          result.push({
            id: folder.id,
            title: displayTitle,
            type: folder.attributes.type,
            originalTitle: folder.attributes.title // Keep original title for reference
          });

          // Recursively process children
          if (folder.children && folder.children.length > 0) {
            const childResults = this.flattenNestedFolders(folder.children, level + 1);
            result = result.concat(childResults);
          }
        }
      }

      return result;
    },
    cancel() {
      this.selectedFolder = null;
      this.$emit('close');
    },
    save() {
      if (!this.selectedFolder) {
        return;
      }

      const destinationFolderId = this.selectedFolder.id;
      let contextType = 'Container';

      if (this.selectedFolder.type === "RootFolder") {
        contextType = 'Channel';
      }

      this.$emit('move', { destinationFolderId, contextType });
      this.selectedFolder = null;
    }
  }
};
</script>
